import React from 'react';
import { Routes, Route, Link } from 'react-router-dom';
import AddressChange from './components/AddressChange/AddressChange';

function App() {
  return (
    <div>
      <Routes>
        <Route path="/" element={<AddressChange />} />
      </Routes>
    </div>
  );
}

export default App;
  